import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-350efcbf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-container"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "news-view"
};
const _hoisted_4 = {
  class: "notice-heading"
};
const _hoisted_5 = {
  class: "notice-icon",
  "aria-hidden": "true"
};
const _hoisted_6 = {
  key: 0,
  class: "notice-feed"
};
const _hoisted_7 = ["title", "onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice-dot",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_9 = {
  class: "notice-title"
};
const _hoisted_10 = {
  key: 1,
  class: "notice-feed notice-empty"
};
const _hoisted_11 = ["aria-label"];
import { ref, onMounted, watch, onBeforeUnmount, onBeforeMount } from 'vue';
import store from '@/store';
import router from '@/router';
import { useRoute } from 'vue-router';
import { useIntersectionObserver } from '@vueuse/core';
import { NotificationOutlined, MenuOutlined } from '@ant-design/icons-vue';
import { userInfo, announceHome, announceDetail, marketInfoRecharge, marketIeo } from '@/apis';
import HomeHero from '@/components/home1/HomeHero.vue';
import HomeMarketList from '@/components/home1/HomeMarketList.vue';
import HomeFeatureCards from '@/components/home1/HomeFeatureCards.vue';
import HomeEcosystem from '@/components/home1/HomeEcosystem.vue';
import HomePocketBanner from '@/components/home1/HomePocketBanner.vue';
import HomeLearnCards from '@/components/home1/HomeLearnCards.vue';
import HomeVoices from '@/components/home1/HomeVoices.vue';
import HomeNewsletter from '@/components/home1/HomeNewsletter.vue';
import NoticePopup from '@/components/NoticePopup.vue';
import { hasSeenNoticePopup, markNoticePopupSeen } from '@/util/noticePopup';

// import { truncateString } from '@/util/tools'

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// import Lottie from '../../components/Lottie/LottieIndex.vue'
// import Animation from '../../assets/lottie/BCLR-Home-New-Animation.json'

export default {
  __name: 'HomePage',
  setup(__props) {
    const route = useRoute();
    const newsList = ref([]);
    const noticePopupVisible = ref(false);
    const noticePopupNotice = ref(null);
    const showLatestNoticePopup = async latestNotice => {
      const token = store.state.token;
      const email = store.state.email;
      if (!latestNotice || hasSeenNoticePopup(latestNotice.id, token, email)) return;
      try {
        const res = await announceDetail({
          id: Number(latestNotice.id)
        });
        if (res.code !== 200 || !res.data) return;
        noticePopupNotice.value = {
          ...latestNotice,
          title: res.data.title || latestNotice.title,
          content: res.data.content || '',
          time: latestNotice.time
        };
        markNoticePopupSeen(latestNotice.id, token, email);
        noticePopupVisible.value = true;
      } catch (error) {
        console.warn('Unable to load notice popup', error);
      }
    };
    const init = async () => {
      try {
        const res = await announceHome({
          platform: 2
        });
        if (res.code === 200 && res.data) {
          dayjs.extend(utc);
          dayjs.extend(timezone);
          const list = Array.isArray(res.data) ? res.data : JSON.parse(res.data);
          newsList.value = list.map(item => {
            return {
              id: item.id,
              title: item.title,
              time: item.createdDate
            };
          });
          await showLatestNoticePopup(newsList.value[0]);
        }
      } catch (error) {
        console.warn('Unable to load announcements', error);
      }
    };
    const langWatch = watch(() => store.state.lang, () => {
      init();
    });
    const getEmail = async () => {
      const res = await userInfo();
      if (res.code === 200 && res.data) {
        store.commit('emailChange', res.data.email);
        localStorage.setItem('pcstore_info', JSON.stringify({
          token: store.state.token,
          time: dayjs().unix(),
          email: store.state.email
        }));
      }
    };
    let sessionReady = Promise.resolve();
    if (route.query.token) {
      store.commit('tokenChange', route.query.token);
      sessionReady = getEmail().catch(() => undefined);
    }
    const advantage1Ref = ref();
    const advantage1Show = ref(false);
    const advantage2Ref = ref();
    const advantage2Show = ref(false);
    const startRef = ref();
    const startShow = ref(false);
    const popularRef = ref();
    const popularShow = ref(false);
    const globalRef = ref();
    const globalShow = ref(false);

    // const registerValue = ref('')

    const coinList = ref([]);
    const getIcon = async () => {
      const res = await marketInfoRecharge({});
      if (res.code === 200 && res.data) {
        coinList.value = res.data.map(item => {
          const data = {
            id: item.id,
            icon: process.env.VUE_APP_IMG + item.icon,
            name: item.marketName,
            min: item.rechargeMin,
            symbol: item.marketSymbol
          };
          return data;
        });
      }
    };
    const buyInfo = ref({
      icon: '',
      name: '',
      symbol: ''
    });
    const getMarketIeo = () => {
      marketIeo({}).then(res => {
        if (res.code === 200 && res.data) {
          buyInfo.value.icon = process.env.VUE_APP_IMG + res.data.icon;
          buyInfo.value.name = res.data.marketName;
          buyInfo.value.symbol = res.data.marketSymbol;
          buyUser.value = res.data.ieoUserNum;
          buyTotal.value = res.data.ieoBuyAmount;

          // startDate.value = dayjs(JSON.parse(res.data).ieoStartTime * 1000).tz("America/New_York").format("MM/DD/YYYY")
          // finishDate.value = dayjs(JSON.parse(res.data).ieoEndTime * 1000).tz("America/New_York").format("MM/DD/YYYY")
          // buyInfo.value.icon = import.meta.env.VITE_IMG + res.data['MESGUSDT'].icon
          // buyInfo.value.name = res.data['MESGUSDT'].marketName
          // buyInfo.value.symbol = res.data['MESGUSDT'].marketSymbol
          // time.value = res.data['MESGUSDT'].ieoEndTime * 1000 - new Date().getTime()
        }
      });
    };

    const buyUser = ref(0);
    const buyTotal = ref(0);
    const time = ref(0);

    // const ieoLastDiff = computed(() => { 
    //   if(store.state.market['DASUSDT']?.last && store.state.market['DASUSDT']?.last != 0){
    //     return (store.state.market['DASUSDT']?.last - 0.018).toFixed(5)
    //   }else {
    //     return 0
    //   }
    // })

    // const ieoLastGrowth = computed(() => { 
    //   if(store.state.market['DASUSDT']?.last && store.state.market['DASUSDT']?.last != 0){
    //     return ((store.state.market['DASUSDT']?.last - 0.018) * 100 / 0.018).toFixed(2)
    //   }else {
    //     return 0
    //   }
    // })

    const advantage1 = () => {
      const {
        stop
      } = useIntersectionObserver(advantage1Ref, ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          advantage1Show.value = true;
          stop();
        }
      });
    };
    const advantage2 = () => {
      const {
        stop
      } = useIntersectionObserver(advantage2Ref, ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          advantage2Show.value = true;
          stop();
        }
      });
    };
    const popularAnimate = () => {
      const {
        stop
      } = useIntersectionObserver(popularRef, ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          popularShow.value = true;
          stop();
        }
      });
    };
    const startAnimate = () => {
      const {
        stop
      } = useIntersectionObserver(startRef, ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          startShow.value = true;
          stop();
        }
      });
    };
    const globalAnimate = () => {
      const {
        stop
      } = useIntersectionObserver(globalRef, ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          globalShow.value = true;
          stop();
        }
      });
    };
    onBeforeMount(() => {
      getIcon();
    });
    onMounted(async () => {
      await sessionReady;
      init();
      advantage1();
      advantage2();
      startAnimate();
      popularAnimate();
      globalAnimate();
      getMarketIeo();
      time.value = 1772038800000 - new Date().getTime();
    });
    onBeforeUnmount(() => {
      langWatch();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HomeHero), _createElementVNode("section", {
        class: "notice-view",
        "aria-label": _ctx.$t('bulletin')
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_unref(NotificationOutlined))])]), newsList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value.slice(0, 2), item => {
        return _openBlock(), _createElementBlock("button", {
          key: item.id,
          class: "notice-entry",
          type: "button",
          title: item.title,
          onClick: $event => _unref(router).push({
            name: 'article',
            params: {
              id: item.id
            }
          })
        }, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1)], 8, _hoisted_7);
      }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('viewMore')), 1)), _createElementVNode("button", {
        class: "notice-all",
        type: "button",
        "aria-label": _ctx.$t('homeremind6'),
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
          name: 'notice'
        }))
      }, [_createVNode(_unref(MenuOutlined), {
        "aria-hidden": "true"
      })], 8, _hoisted_11)])], 8, _hoisted_2), _createVNode(HomeMarketList), _createVNode(HomeFeatureCards), _createVNode(HomeEcosystem), _createVNode(HomePocketBanner), _createVNode(HomeLearnCards), _createVNode(HomeVoices), _createVNode(HomeNewsletter), noticePopupNotice.value ? (_openBlock(), _createBlock(NoticePopup, {
        key: 0,
        modelValue: noticePopupVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => noticePopupVisible.value = $event),
        notice: noticePopupNotice.value
      }, null, 8, ["modelValue", "notice"])) : _createCommentVNode("", true)]);
    };
  }
};